export var appStoreURL = 'https://notonthehighstreet.onelink.me/XbOV/f42cf824';
export var googlePlayURL = 'https://notonthehighstreet.onelink.me/XbOV/19e5d1a0';